const DEV_BYPASS_ENV = process.env.EXPO_PUBLIC_KURSI_PLAY_DEV_BYPASS;
const DEV_CREATOR_ID_ENV = process.env.EXPO_PUBLIC_KURSI_PLAY_DEV_CREATOR_ID;

const DEFAULT_DEV_CREATOR_ID = '00000000-0000-4000-8000-000000000001';

export function isKursiPlayDevBypassEnabled(): boolean {
  if (DEV_BYPASS_ENV === '1' || DEV_BYPASS_ENV === 'true') return true;
  if (DEV_BYPASS_ENV === '0' || DEV_BYPASS_ENV === 'false') return false;
  return typeof __DEV__ !== 'undefined' ? __DEV__ : false;
}

export function getKursiPlayDevCreatorId(): string {
  return DEV_CREATOR_ID_ENV?.trim() || DEFAULT_DEV_CREATOR_ID;
}

export function isCreatorForeignKeyError(message?: string): boolean {
  if (!message) return false;
  const msg = message.toLowerCase();
  return (
    msg.includes('gamified_courses_creator_id_fkey') ||
    (msg.includes('foreign key') && msg.includes('creator_id'))
  );
}
